export const PageViewEventData = {
  event: "pageview",
  domain: "",
  page_location: "",
  page_title: "",
  page_type: "",
  country: "",
  state: "",
  property_id: "",
  property_name: "",
  property_location: "",
  ld_user_id: "",
};
